
namespace RioERP.Masters {
    export class DelhiveryApiDetailsColumns {
        static columnsKey = 'Masters.DelhiveryApiDetails';
    }
}